import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-black text-center w-full mt-2" }, "Droga! Acontecer algum erro.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center w-full mt-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "rounded-full font-regular text-sm flex flex-col justify-center bg-brand-gray items-center py-2 px-5 cursor-pointer focus:outline-none"
  }, " Tente novamente ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UseIcon = _resolveComponent("UseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UseIcon, {
      name: "IconError",
      color: "#F88676",
      size: "70"
    }),
    _hoisted_2,
    _hoisted_3
  ]))
}